import * as React from "react";
const SvgFiRrChessQueen = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chess-queen_svg__a)">
      <path
        fill="#062147"
        d="M23.449 9.627a2.01 2.01 0 0 0-1.87-.587c-.214.043-.423.1-.63.156a10.83 10.83 0 0 0-7.1-5.032 2.5 2.5 0 1 0-3.7 0A10.83 10.83 0 0 0 3.052 9.2a8 8 0 0 0-.63-.156A2.01 2.01 0 0 0 .064 10.51c-.084.33-.083.676.005 1.006l2.9 10.493A1 1 0 0 0 3 24h18a1 1 0 0 0 .03-1.994l2.907-10.515a1.98 1.98 0 0 0-.488-1.864M11.999 6a8.52 8.52 0 0 1 7.088 4.005 6.9 6.9 0 0 0-2 1.807 6 6 0 0 0-10.163 0 6.8 6.8 0 0 0-2-1.807A8.52 8.52 0 0 1 12 6m6.959 16H5.045l-3.02-11C4 11.4 6 12.9 6 15a1 1 0 1 0 2 0 4 4 0 0 1 8 0 1 1 0 1 0 2 0c0-2.1 2-3.6 4-4.021z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chess-queen_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChessQueen;
